import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { clearAuth, getUser } from "../utils/auth";

const AdminPanel = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearAuth();
    navigate("/");
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" fontWeight={600}>
        Admin Panel
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Signed in as {user?.email}
      </Typography>
      <Button variant="outlined" onClick={handleLogout}>
        Log Out
      </Button>
    </Box>
  );
};

export default AdminPanel;
